import classNames from 'classnames'
import React from 'react'
import styled from 'styled-components'

export const MenuItemLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const SettingsPageSubSelector = styled.a`
  padding: ${({ theme }) => theme.spacing.md}rem;
  display: flex;
  color: ${({ theme }) => theme.colors.neutralBlack};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  margin-left: 0;
  margin-right: ${({ theme }) => theme.spacing.xs}rem;
  border-radius: 0.75rem;
  border: 1px solid transparent;
  background: ${({ theme }) => theme.colors.neutralWhite};
  position: relative;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  outline: none;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    color: ${({ theme }) => theme.colors.iconGrayDark};
  }

  .icon-wrapper img {
    width: 1rem;
    height: 1rem;
    object-fit: contain;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.defaultHover};
    border-color: ${({ theme }) => theme.colors.neutralGray};
    color: ${({ theme }) => theme.colors.neutralBlack};
    text-decoration: none;
  }

  &.active {
    background: ${({ theme }) => theme.colors.neutralWhite};
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }

  &:hover .icon-wrapper {
    color: ${({ theme }) => theme.colors.iconGrayDark};
  }

  &.active .icon-wrapper {
    color: ${({ theme }) => theme.colors.primary};
  }

  .item-name {
    flex: 1;
  }
`

export const SettingsSubNavItem: React.FC<{
  link: string
  icon: React.ReactNode
  name: string
  isActive: boolean
  onSelect: (link: string) => void
  suffix?: React.ReactNode
}> = ({ link, icon, name, isActive, onSelect, suffix }) => (
  <SettingsPageSubSelector
    href="#"
    onClick={e => {
      onSelect(link)
      e.preventDefault()
    }}
    className={classNames({ active: isActive })}
  >
    <span className="icon-wrapper">{icon}</span>
    <span className="item-name">
      <MenuItemLabel>
        {name}
        {suffix}
      </MenuItemLabel>
    </span>
  </SettingsPageSubSelector>
)
